import Modal from 'react-bootstrap/Modal'
import CreditIcon from "../assets/CreditIcon.svg"
import Moment from 'react-moment'

function PaymentModal(props) {
  const ptData = props.ptdata
  const fees = ptData.transaction_fees

  return (
    <Modal
    {...props}
    size="md"
    aria-labelledby="contained-modal-title-vcenter"
    centered
  >
    <Modal.Header closeButton>
    <Moment className="trans-amt" format=" MMMM Do, YYYY">{ptData.createdAt}</Moment>
    </Modal.Header>
    <Modal.Body >
        <div className='trans-type'>
           <h6>Payment Received</h6> 
           <img className="modal-debit-icon" src={CreditIcon} alt="debit" />
        </div>
      <div className='acct-name modal-sub-groups'>
          <h6>Name</h6>
          <p>{ptData.customer_name}</p>
      </div>
      <hr/>
      <div className='acct-no modal-sub-groups'>
          <h6>Email</h6>
          <p>{ptData.customer_email}</p>
      </div>
      <hr/>
      <div className='bank-name modal-sub-groups'>
          <h6>Narration</h6>
          <p>{ptData.narration}</p>
      </div>
      <hr/>
      <div className='fee modal-sub-groups'>
          <h6>Fee Charge</h6>
          <p> ₦{fees}</p>
      </div>
      <hr/>
      <div className='amt modal-sub-groups'>
          <h6>Amount</h6>
          <h5 className="text-success debit"> {ptData.amount}</h5>
      </div>
    </Modal.Body>
  </Modal>
  )
}

export default PaymentModal